var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-mode-nav"},[_c('div',{staticClass:"nav"},[_vm._l((_vm.navs),function(item){return [_c('span',{key:item.key,class:{
          active: item.key === _vm.platform,
        },attrs:{"data-key":item.key},on:{"click":_vm.handleSwitchNav}},[_vm._v(_vm._s(item.name))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }